import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import locale from "@aligov/global-locale";

import zhTranslations from "./locales/zh.json";
import enTranslations from "./locales/en.json";
import thTranslations from "./locales/th.json";

// x-hng cookie 中保存的语言标（如 en-US/th-TH/zh-CN）与 i18next 资源 key 的映射
const langMap = {
  "zh-CN": "zh",
  "en-US": "en",
  "th-TH": "th",
};

// 优先使用用户此前通过语言切换按钮保存在 x-hng cookie 中的语言偏好，避免刷新后被重置为泰语；
// 仅在从未保存过语言时才兜底使用泰语
const { lang: savedLang } = locale.getLocale();
const initialLng = (savedLang && langMap[savedLang]) || "th";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: {
        translation: zhTranslations,
      },
      en: {
        translation: enTranslations,
      },
      th: {
        translation: thTranslations,
      },
    },
    lng: initialLng,
    fallbackLng: "th",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
